module.exports = __webpack_public_path__ + "media/images/career_camp/2023/intro_bg-c28bdcfa3976c302e90a64e396f1fa9b.jpg";